/*
 * Controller to ensure an element's min-height uses the entirety of vertical space available,
 * regardless of how deeply the element is nested or if it has sticky elements, etc.
 *
 * Values:
 *   bottomSelector: Optional. CSS selector to match content that appears below the space-
 *                   filling element. The height of this content will be subtracted from the
 *                   element's min-height.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    bottomSelector: String,
  };

  static outlets = ["scroll-snap"];

  connect() {
    if (this.hasBottomSelectorValue) {
      this.bottomElement = document.querySelector(this.bottomSelectorValue);
    }

    this.update();
  }

  update() {
    const minimum = this.calculateMinimumHeight();

    if (this.element.getBoundingClientRect().height < minimum) {
      this.element.style["min-height"] = minimum + "px";
    }

    // height change may have caused scroll to move up from bottom,
    // so let snapper update if present
    if (this.hasScrollSnapOutlet) {
      this.scrollSnapOutlet.update();
    }
  }

  calculateMinimumHeight() {
    var min = window.innerHeight - this.element.getBoundingClientRect().y;

    if (this.bottomElement) {
      min = min - this.bottomElement.getBoundingClientRect().height;
    }

    return min;
  }
}
